export function isRenderer(value) {
    return value && value.onRendered !== undefined &&
        value.invalidate !== undefined && value.awaitRendered !== undefined;
}
export function asRenderer(o) {
    return isRenderer(o) ? o : null;
}
//# sourceMappingURL=renderer.js.map